import React from "react";
import "./styles.scss";

const appleLogoLight = require("../../assets/icons/apple/light.svg");
const appleLogoDark = require("../../assets/icons/apple/dark.svg");

export default props => {
  let darkStyle = props.dark || false
  return (
    <button className={ darkStyle ? "purchase-button dark" : "purchase-button light"} 
            onClick={event => props.onClick(event)}>
      <img className="purchase-button-icon" src={ darkStyle ? appleLogoDark : appleLogoLight} alt="apple logo" />
      <div className="purchase-button-text-container">
        <p className="purchase-button-text light">{"Available on"}</p>
        <p className="purchase-button-text bold">{"App Store"}</p>
      </div>
    </button>
  );
};
